import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './PedidoCommentModal.scss';

interface PedidoCommentModalProps {
  show: boolean;
  onHide: () => void;
  comment: string;
  onCommentChange: (comment: string) => void;
}

const PedidoCommentModal: React.FC<PedidoCommentModalProps> = ({
  show,
  onHide,
  comment,
  onCommentChange,
}) => {
  const [localComment, setLocalComment] = useState(comment);

  // Sync local state with prop when modal opens
  useEffect(() => {
    if (show) {
      setLocalComment(comment);
    }
  }, [show, comment]);

  const handleSave = () => {
    onCommentChange(localComment);
    onHide();
  };

  const handleClear = () => {
    setLocalComment('');
    onCommentChange('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">
            Comentario del Pedido
          </Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          ×
        </Button>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>
            Comentario opcional para la cocina
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={localComment}
            onChange={(e) => setLocalComment(e.target.value)}
            placeholder="Ej: Sin sal, extra picante, etc..."
            maxLength={200}
            className="pedido-comment-textarea"
          />
          <Form.Text className="text-muted">
            {localComment.length}/200 caracteres
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className="btn form-button-cancel" onClick={handleClear}>
            Limpiar
          </Button>
          <Button variant="none" className="btn form-button-create" onClick={handleSave}>
            Guardar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PedidoCommentModal;
